module.exports = __webpack_public_path__ + "static/media/14UNEP18.65b3a3ca.jpg";